/**
 * A short reference code for an error screen — the `ref 8f2c-11` on boards 6a
 * and 7f.
 *
 * DETERMINISTIC, and that is the whole point. A random code would look
 * traceable and be worthless: nothing in this app writes it anywhere, so
 * support could never look one up. Hashing the facts that identify the incident
 * instead means the same user hitting the same organization always quotes the
 * same ref, and an engineer holding those facts can regenerate it to confirm
 * they are looking at the right thing.
 *
 * It is an aid to a conversation, not an audit record and not a secret. The
 * inputs are already known to both sides before the code is quoted.
 *
 * FNV-1a, because it is eight lines and needs no crypto: this is a
 * human-readable label, so collisions cost a clarifying question and nothing
 * more.
 */
export function buildIncidentRef(...parts: readonly string[]): string {
  const seed: string = parts.join("|");

  // 32-bit FNV-1a. `>>> 0` after each step keeps it unsigned — without it the
  // multiply overflows into a negative and the hex comes out sign-prefixed.
  let hash: number = 0x811c9dc5;
  for (let i: number = 0; i < seed.length; i += 1) {
    hash ^= seed.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }

  const hex: string = hash.toString(16)
.padStart(8, "0");

  return `${hex.slice(0, 4)}-${hex.slice(4, 6)}`;
}
